import { isNullOrUndefined } from '@vy/utils';
import { useMemo } from 'react';
import { usePageParam } from '../../../../hooks/search-params/use-page-param';
import { usePageSizeParam } from '../../../../hooks/search-params/use-page-size-param';
import { deserializeStringArrayParam } from '../../../../utils/params-formatting';
import type { DataMeteringParamsIds } from '../data-metering-types/data-metering-param-ids';

export function useDataMeteringParamsIds(searchParams: URLSearchParams) {
  const customersIds = useMemo(() => {
    return searchParams.get('customers') ? searchParams.get('customers')?.split(',') : [];
  }, [searchParams]);

  const eventNames = useMemo(() => {
    const paramEventNames = searchParams.get('eventNames');
    if (isNullOrUndefined(paramEventNames)) {
      return [];
    }

    return deserializeStringArrayParam(paramEventNames);
  }, [searchParams]);

  const metersIds = useMemo(() => {
    return searchParams.get('meters')?.split(',');
  }, [searchParams]);

  const [page] = usePageParam();
  const [pageSize] = usePageSizeParam();

  return useMemo<DataMeteringParamsIds>(
    () => ({
      customersIds,
      eventNames,
      metersIds,
      page,
      pageSize,
    }),
    [customersIds, eventNames, metersIds, page, pageSize],
  );
}
